import { defineMessages } from 'react-intl';

export const accountMessages = defineMessages({
  dietaryRestrictionsTitle: {
    defaultMessage: 'Dietary restrictions',
    description: 'Account Screen | Dietary restrictions tab | Title',
  },
});
